// Price-tier helpers — used to color seat-map sections like a heat map and
// to label listings by tier ("Premium", "Lower", etc).

export type Tier = 0 | 1 | 2 | 3;

export const TIER_META: Record<
  Tier,
  { label: string; gradient: string; solid: string; soft: string }
> = {
  0: {
    label: "Value",
    gradient: "linear-gradient(135deg, #0ea5a4 0%, #10b981 100%)",
    solid: "#10b981",
    soft: "rgba(16, 185, 129, 0.15)",
  },
  1: {
    label: "Standard",
    gradient: "linear-gradient(135deg, #2563eb 0%, #38bdf8 100%)",
    solid: "#38bdf8",
    soft: "rgba(56, 189, 248, 0.15)",
  },
  2: {
    label: "Prime",
    gradient: "linear-gradient(135deg, #d97706 0%, #f59e0b 100%)",
    solid: "#f59e0b",
    soft: "rgba(245, 158, 11, 0.15)",
  },
  3: {
    label: "Premium",
    gradient: "linear-gradient(135deg, #be185d 0%, #ec4899 100%)",
    solid: "#ec4899",
    soft: "rgba(236, 72, 153, 0.15)",
  },
};

export function priceTier(price: number, allPrices: number[]): Tier {
  if (allPrices.length === 0) return 0;
  const sorted = [...allPrices].sort((a, b) => a - b);
  const min = sorted[0]!;
  const max = sorted[sorted.length - 1]!;
  if (max === min) return 0;
  const pct = (price - min) / (max - min);
  if (pct < 0.25) return 0;
  if (pct < 0.5) return 1;
  if (pct < 0.75) return 2;
  return 3;
}
